module.exports = __webpack_public_path__ + "static/5-generate-recovery-code-cd59760c572814c9bb66d050e0e675a3.jpg";